import { RecipeType } from "@/types/baseTypes";
import React from "react";
import RecipeStars from "./RecipeStars/RecipeStars";
import RecipeStarsVoting from "./RecipeStarsVoting/RecipeStarsVoting";
import styles from "./RecipeVotingbuttons.module.scss";
import RecipeDownload from "./RecipeDownload/RecipeDownload";
import { useRating } from "@/context/RatingContext.tsx";

interface RecipeVotingButtonsProps {
  recipeDetails: RecipeType;
  favCount: number;
  className?: string;
}

function RecipeVotingButtons({
  recipeDetails,
  favCount,
  className = "",
}: RecipeVotingButtonsProps) {
  const { isVoting } = useRating();
  return (
    <div
      className={`${styles["recipe-voting-buttons"]} ${className}`}
      data-voting={isVoting}
    >
      <div className="is-flex">
        {!isVoting && <RecipeStars />}
        {isVoting && <RecipeStarsVoting />}
      </div>
      <div>
        <RecipeDownload favCount={favCount} recipeDetails={recipeDetails} />
      </div>
    </div>
  );
}

export default RecipeVotingButtons;
